import styled from 'styled-components';
import { TextStyle } from 'components/text';
import { FontSize, FontWeight } from 'commons';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FileFeedback = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 4px;
`;

export const FileError = styled.p`
  color: ${({ theme }) => theme.danger_300};
  font-size: ${FontSize.font10};
  font-weight: ${FontWeight.bold};
`;

export const FileInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 18px;
  background-color: ${({ theme }) => theme.neutral_200};

  ${TextStyle} {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const RemoveFile = styled.button`
  color: ${({ theme }) => theme.danger_300};
  font-size: ${FontSize.font12};
  font-weight: ${FontWeight.bold};
  cursor: pointer;
  display: flex;
  align-items: center;
`;
